<template>
    <div class="content">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: 'Content'
}
</script>

<style>
    .content{
         grid-area: 'Content';
         /*width: 90%;
         margin: 0 auto;*/
             width: calc(100% - 208px);
            margin-left: 208px;
    }

    @media screen and (max-width: 949px){
        .content{
            width: 100%;
            margin-left: 0px;
        }
    }
</style>
